import React from "react";

import { Input } from "semantic-ui-react";

import css from "../../assets/styles/polls/pollEditableField.module.scss";
const TextInput = ({
  name,
  onChange,
  toggleEdit,
  style,
  placeholder,
  onKeyDown,
  autoFocus,
}) => {
  return (
    <Input
      autoFocus={autoFocus}
      input={{ style }}
      className={css.inputField}
      onChange={onChange}
      onBlur={toggleEdit}
      value={name}
      placeholder={placeholder}
      onKeyDown={onKeyDown}
    />
  );
};

const PollEditableField = ({
  name,
  onChange,
  style,
  placeholder,
  onKeyDown,
  autoFocus,
}) => {
  return (
    <TextInput
      name={name}
      onChange={(e, data) => onChange(data.value)}
      style={style}
      placeholder={placeholder}
      onKeyDown={onKeyDown}
      autoFocus={autoFocus}
    />
  );
};

export default PollEditableField;
